module.exports = __webpack_public_path__ + "media/images/nereport/icon_fb-1c7b0ac92ade4a3f90112225e63830de.svg";